var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',{staticClass:"flex flex-col justify-between min-h-screen"},[_c('Nuxt'),_vm._v(" "),_c('LayoutHeader')],1),_vm._v(" "),_c('SocialLinks'),_vm._v(" "),_c('ErrorPanel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }